import React from 'react';
import { CameraScanButtonProps } from './types';

export const CameraScanButton: React.FC<CameraScanButtonProps> = ({
  onClick,
  disabled = false,
  className = '',
  'aria-label': ariaLabel = 'Scan barcode with camera'
}) => {
  return (
    <button
      type="button"
      className={`camera-scan-btn ${className}`}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      title="Scan QR code or barcode"
    >
      <svg 
        viewBox="0 0 24 24" 
        width="20" 
        height="20" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2"
        strokeLinecap="round" 
        strokeLinejoin="round"
      >
        <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
        <circle cx="12" cy="13" r="4"/>
      </svg>
    </button>
  );
};